import ApiService from '@jobstairs/axios-api-service';
import tokenService from '@/services/TokenService';

export default class PushPullAnalysisService {
    #config;
    #apiService;

    constructor(config) {
        this.#config = config;
        this.#apiService = new ApiService({ baseURL: config.baseURL });
    }

    async analyze(text, title = '') {
        const headers = tokenService.getAuthenticationHeader()['headers'];
        const { data } = await this.#apiService.post({
            endpoint: this.#config.endpoint,
            data: { title, text, language: 'de' },
            headers,
        });
        data.highlights = this.transformHighlights(data.highlights);
        return data;
    }

    transformHighlights(highlights) {
        let tmp = [];
        highlights.sort((a, b) => {
            if (a.position.start < b.position.start) {
                return -1;
            }
            if (a.position.start > b.position.start) {
                return 1;
            }
            return 0;
        });

        for (let i = 0; i < highlights.length; i++) {
            let v = highlights[i];
            let position = {
                start: v.position.start,
                end: v.position.end,
            };
            let advice = {
                phrase: v.phrase,
                adviceText: v.advice,
                class: v.class,
            };

            let start = v.position.start;
            let end = v.position.end;
            for (let j = i + 1; j < highlights.length; j++) {
                let u = highlights[j];
                start = u.position.start;
                if (start < end) {
                    end = u.position.end;
                    if (advice.class.weight < u.class.weight) {
                        advice = {
                            phrase: u.phrase,
                            adviceText: u.advice,
                            class: u.class,
                        };
                        position = {
                            start: u.position.start,
                            end: u.position.end,
                        };
                    }
                    i++;
                } else {
                    break;
                }
            }
            tmp.push({
                position,
                advice,
            });
        }
        return tmp;
    }
}
